module.exports = __webpack_public_path__ + "img/icon-menu-fx-alert.f0af673a.svg";